module.exports = __webpack_public_path__ + "img/logo.7667b5d3.png";